import React from 'react';

const Textarea = ({ 
  value,
  onChange,
  placeholder,
  disabled = false,
  readOnly = false,
  required = false,
  rows = 4,
  className = '',
  error = false,
  size = 'md',
  ...props 
}) => {
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-2';
  const baseClasses = `w-full ${sizeClasses} border rounded-md focus:outline-none transition-colors resize-vertical`;
  
  const stateClasses = {
    normal: 'border-gray-300 focus:ring-2 focus:ring-naviter-blue focus:border-transparent',
    error: 'border-red-300 focus:ring-2 focus:ring-red-500 focus:border-transparent',
    disabled: 'bg-gray-50 text-gray-700 cursor-not-allowed border-gray-300',
    readOnly: 'bg-gray-50 text-gray-700 cursor-not-allowed border-gray-300'
  };

  let stateClass;
  if (disabled || readOnly) {
    stateClass = disabled ? stateClasses.disabled : stateClasses.readOnly;
  } else if (error) {
    stateClass = stateClasses.error;
  } else {
    stateClass = stateClasses.normal;
  }

  const classes = `${baseClasses} ${stateClass} ${className}`.trim();

  return (
    <textarea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      required={required}
      rows={rows}
      className={classes}
      {...props}
    />
  );
};

export default Textarea;
